import { formatPrice } from "../helpers";
import PanelController from "./panel-controller";

export default class extends PanelController {
    static targets = ["panel", "item", "form", "messaging"];

    togglePanel(e, variant, product) {
        this.active = !this.active;
        e?.preventDefault();

        if (this.active) {
            this.buildItem(variant, product);
            this.panelTarget.classList.add("panel--active");
            document.body.classList.add("no-scroll");
        } else {
            this.panelTarget.classList.remove("panel--active");
            document.body.classList.remove("no-scroll");
            this.clearItem();
        }
    }

    buildItem(variant, product) {
        let itemHTML = this.itemTarget.innerHTML;
        const { innerText, dataset, parentElement } = variant;

        const wrap = document.createElement("div");
        wrap.innerHTML = this.itemTarget.innerHTML;

        wrap.querySelector(".line-item__image").src = dataset.imageSrc;
        wrap.querySelector(".line-item__variant").innerText = innerText;
        wrap.querySelector(".line-item__title").innerText =
            parentElement.dataset.product;
        wrap.querySelector(".line-item__price").innerText = formatPrice(
            dataset.price
        );

        this.itemTarget.innerHTML = wrap.innerHTML;

        const variantInput = this.formTarget.querySelector(
            'input[name="variant"]'
        );
        const productInput = this.formTarget.querySelector(
            'input[name="product"]'
        );

        if (!variantInput.value || !productInput.value) {
            variantInput.value = variant.value;
            productInput.value = product.getAttribute("id");
        }
    }

    clearItem() {
        const src =
            this.itemTarget.querySelector(".line-item__image").dataset.src;
        const dataSrc = src;
        this.itemTarget.innerHTML = `
      <img class="line-item__image" src="${src}" alt="{{title}}" data-src="${dataSrc}" height="110" width="110" loading="lazy" />
      <div>
        <h3 class="line-item__title">{{title}}</h3>
        <p class="line-item__variant">{{variant}}</p>
        <p class="line-item__price">{{price}}</p>
      </div>
    `;
    }

    handleError() {
        this.messagingTarget.classList.remove("hidden");
        this.messagingTarget.innerHTML = `<p class="panel__message panel__message--error">Sorry there was an issue submitting the form. Please try again or get in touch.</p>`;
    }

    async submitForm(e) {
        e.preventDefault();
        const form = e.target;

        if (form) {
            const fields = form.querySelectorAll("input");

            const payload = {};
            fields.forEach((field) => (payload[field.name] = field.value));

            const config = {
                method: "POST",
                headers: {
                    accept: "application/vnd.api+json",
                    "content-type": "application/vnd.api+json",
                    revision: "2024-10-15",
                },
            };

            try {
                const initialRes = await fetch(form.action, {
                    ...config,
                    body: JSON.stringify({
                        data: {
                            type: "back-in-stock-subscription",
                            attributes: {
                                profile: {
                                    data: {
                                        type: "profile",
                                        attributes: {
                                            email: payload.email
                                        }
                                    },
                                },
                                channels: [
                                    "EMAIL"
                                ]
                            },
                            relationships: {
                                variant: {
                                    data: {
                                        id: `$shopify:::$default:::${payload.variant}`,
                                        type: "catalog-variant",
                                    },
                                },
                            },
                        },
                    }),
                });

                // if (initialRes.ok && secondaryRes && secondaryRes.ok) {
                if (initialRes.ok) {
                    this.formTarget.classList.add("hidden");
                    const initialData = await initialRes.json();

                    if (initialData.success) {
                        this.messagingTarget.innerHTML = `<p class="panel__message panel__message--success">You have successfully signed up to be notified when our new stock arrives.</p>`;
                    } else {
                        this.handleError();
                    }

                    this.messagingTarget.classList.remove("hidden");
                } else {
                    this.handleError();
                }
            } catch (error) {
                this.handleError();
                console.log(`THERE WAS AN ERROR >> ${error}`);
            }
        }
    }
}
